import { useTheme } from "@/hooks/useTheme";
import { Stack, router, useSegments, useGlobalSearchParams } from "expo-router";
import { Pressable, Platform } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { MaterialIcons } from "@expo/vector-icons";
import * as Haptics from "expo-haptics";
import useAuth from "@/hooks/useAuth";

function BackNavigator({ title, toShiftDetail }: { title?: string; toShiftDetail?: boolean }) {
  const { colors } = useTheme();
  const segs = useSegments();
  // useGlobalSearchParams (not Local): nested [shift] routes do not hand Local the parent param -> stuck loading
  const params = useGlobalSearchParams<{ shift?: string }>();

  const handlePress = () => {
    if (Platform.OS !== "web") {
      Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
    }
    const basePath = (segs as string[]).includes("crew") ? "/crew/supervising" : "/supervising";
    if (toShiftDetail && params.shift) {
      // Navigate back to shift detail
      router.replace(`${basePath}/${params.shift}` as any);
    } else {
      // Navigate back to supervising list
      router.replace(basePath as any);
    }
  };

  return (
    <Pressable
      onPress={handlePress}
      style={({ pressed }) => ({
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 4,
        opacity: pressed ? 0.7 : 1,
        minWidth: 60,
      })}
    >
      <MaterialIcons color={colors.primary} size={24} name="chevron-left" />
      {title && (
        <ThemedText
          style={{
            color: colors.primary,
            fontSize: 17,
            fontWeight: "400",
            marginLeft: 2,
          }}
        >
          {title}
        </ThemedText>
      )}
    </Pressable>
  );
}

export default function SupervisingShiftLayout() {
  const { colors } = useTheme();
  const { displayNames } = useAuth();
  const shiftName = displayNames?.shifts?.name || "Shift";

  return (
    <Stack
      screenOptions={{
        headerShadowVisible: false,
        contentStyle: {
          backgroundColor: colors.backgroundSecondary,
        },
        headerStyle: {
          backgroundColor: colors.backgroundSecondary,
        },
        headerTitle: `Supervised ${shiftName}`,
        headerTitleAlign: "center",
        headerTitleStyle: {
          color: colors.text,
          fontWeight: "600",
          fontSize: 18,
        },
      }}
    >
      <Stack.Screen
        options={{ animation: "simple_push", headerLeft: () => <BackNavigator title={"Back"} /> }}
        name="index"
      />
      <Stack.Screen
        name="user/[user]"
        options={{
          animation: "simple_push",
          headerTitle: "Crew Member",
          headerLeft: () => <BackNavigator title="Back" toShiftDetail />,
        }}
      />
      <Stack.Screen
        name="contact"
        options={{
          animation: "simple_push",
          headerTitle: "Onsite Contact",
          headerLeft: () => <BackNavigator title="Back" toShiftDetail />,
        }}
      />
      <Stack.Screen
        name="survey"
        options={{
          animation: "simple_push",
          headerTitle: `${shiftName} Survey`,
          headerLeft: () => <BackNavigator title="Back" toShiftDetail />,
        }}
      />
      <Stack.Screen
        name="expense"
        options={{
          animation: "simple_push",
          headerTitle: "Expense",
          headerLeft: () => <BackNavigator title="Back" toShiftDetail />,
        }}
      />
      <Stack.Screen
        name="incident"
        options={{
          animation: "simple_push",
          headerTitle: "Report Incident",
          headerLeft: () => <BackNavigator title="Back" toShiftDetail />,
        }}
      />
    </Stack>
  );
}
